var _defs, _rect, _path, _g, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1718",
    "data-name": "Group 1718",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 255,
    height: 388.911,
    viewBox: "0 0 255 388.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2777",
    "data-name": "Rectangle 2777",
    width: 255,
    height: 388.911,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2776",
    "data-name": "Rectangle 2776",
    width: 255,
    height: 388.911,
    rx: 10,
    transform: "translate(0)",
    fill: "#cad9f9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3134",
    "data-name": "Path 3134",
    d: "M11.9,215.617v21.052L143.409,368.177,266.9,244.684V130.529L181.947,45.573Z",
    transform: "translate(-11.902 -5.27)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1701",
    "data-name": "Group 1701",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1700",
    "data-name": "Group 1700",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    x2: 142.033,
    y2: 142.033,
    transform: "translate(152.428 57.919)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "6.261 6.261"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    "data-name": "Line 99",
    x2: 97.992,
    y2: 97.992,
    transform: "translate(159.584 94.804)",
    fill: "none",
    stroke: "#394277",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    x2: 62.484,
    y2: 62.484,
    transform: "translate(138.114 116.274)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    "data-name": "Line 101",
    x2: 46.794,
    y2: 46.794,
    transform: "translate(123.25 131.138)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_102",
    "data-name": "Line 102",
    x2: 62.484,
    y2: 62.484,
    transform: "translate(108.386 146.002)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_103",
    "data-name": "Line 103",
    x2: 30.279,
    y2: 30.279,
    transform: "translate(93.522 160.866)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_104",
    "data-name": "Line 104",
    x2: 55.052,
    y2: 55.052,
    transform: "translate(78.658 175.73)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_105",
    "data-name": "Line 105",
    x2: 14.864,
    y2: 14.864,
    transform: "translate(221.242 199.402)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Line_106",
    "data-name": "Line 106",
    x2: 14.864,
    y2: 14.864,
    transform: "translate(206.378 214.266)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    x2: 14.864,
    y2: 14.864,
    transform: "translate(191.514 229.13)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    x2: 14.864,
    y2: 14.864,
    transform: "translate(176.65 243.994)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "Line_109",
    "data-name": "Line 109",
    x2: 14.864,
    y2: 14.864,
    transform: "translate(161.786 258.858)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "Line_110",
    "data-name": "Line 110",
    x2: 142.033,
    y2: 142.033,
    transform: "translate(18.101 192.246)",
    fill: "none",
    stroke: "#a3a3d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    strokeDasharray: "6.261 6.261"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1703",
    "data-name": "Group 1703",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1702",
    "data-name": "Group 1702",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3135",
    "data-name": "Path 3135",
    d: "M26.1,250.068s37.584,18.474,47.141,5.1-38.859-8.282-36.311,5.733,21.659,11.467,21.659,11.467a10,10,0,0,0,1.911,12.1c5.733,5.733,13.378,7.007,19.111,10.192s5.1,15.289,7.644,17.837,15.289,8.919,15.289,3.822-8.282.638-1.274,11.467,13.378,12.1,13.378,12.1",
    transform: "translate(-13.544 -28.607)",
    fill: "none",
    stroke: "#394277",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage1);
export default __webpack_public_path__ + "static/media/image1.067e7e619c3bdac74d799fc4ac89335d.svg";
export { ForwardRef as ReactComponent };